import { FLOW_STATES, FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import i18n from '@/i18n/index.js'

export const e2eCompensationsSlidesConfig = () => {
  return [
    {
      name: FLOW_STATES.GAG_DETAILS,
      transition: FLOW_TRANSITIONS.SHOW_GAG_RESUME,
      img: 'slide_gag',
      title: i18n.t('claim.compensationType.e2eCompensations.gagDetail.title'),
      text: i18n.t('claim.compensationType.e2eCompensations.gagDetail.text'),
      link: i18n.t('claim.compensationType.e2eCompensations.gagDetail.link'),
      recommended: true,
      amount: null,
      indemnisation: null
    },
    {
      name: FLOW_STATES.REN_DETAILS,
      transition: FLOW_TRANSITIONS.SHOW_REN_RESUME,
      img: 'slide_ren',
      title: i18n.t('claim.compensationType.e2eCompensations.renDetail.title'),
      text: i18n.t('claim.compensationType.e2eCompensations.renDetail.text'),
      text2: i18n.t('claim.compensationType.e2eCompensations.renDetail.text2'),
      link: i18n.t('claim.compensationType.e2eCompensations.renDetail.link'),
      recommended: false,
      amount: null
    },
    {
      name: FLOW_STATES.BILLMA_DETAILS,
      transition: FLOW_TRANSITIONS.SHOW_BILLMA,
      img: 'slide_billma',
      title: i18n.t('claim.compensationType.e2eCompensations.billma.title'),
      text: i18n.t('claim.compensationType.e2eCompensations.billma.text'),
      link: i18n.t('claim.compensationType.e2eCompensations.billma.link'),
      recommended: false,
      amount: null
    }
  ]
}
